module.exports = __webpack_public_path__ + "img/logo.5901f70d.svg";